const dev = {
  API_ENDPOINT_SWAGGER: 'http://localhost:8000/documentation/content',
  API_ENDPOINT_URL: 'http://localhost:8000/api'
};

const prod = {
  API_ENDPOINT_SWAGGER: 'https://onelivestream.ru/documentation/content',
  API_ENDPOINT_URL: process.env.REACT_APP_API_ENDPOINT
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case 'production':
      return prod;
    default:
      return dev;
  }
};


export const env = getEnv();
